import { useEffect, useState } from "react";
import styles from "./index.module.css";

const NavDropdown = (props)=>{
    const [expand,setExpand] = useState(false);

    useEffect(()=>{
        setExpand(props?.default)
    },[props?.default]);

    const toggleExpand = ()=>setExpand(state=>!state);

    return <div className={styles["nav_dropdown"]}>
        <div className={styles["nav_item"]} onClick={toggleExpand}>
            <div className={expand?styles["rotate"]:""}>
                <i class={`bi ${props.icon}`}></i>
            </div>
            <div>{props?.title}</div>
        </div>
        <div className={expand?`${styles["nav_body"]} ${styles["expand"]}`:styles["nav_body"]}>
        {props.children}
        </div>
    </div>;
}

export default NavDropdown;